import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "@env/environment";
import { Self, SelfModel } from "@models/self.model";
import { map, Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SelfService {
  private _cachedSelf: Self | null = null;

  constructor(private http: HttpClient) {}

  public cachedSelf$(): Observable<Self> {
    if (this._cachedSelf) {
      // If we have a cached version, return an Observable that emits it immediately:
      return of(this._cachedSelf);
    } else {
      // Otherwise, go fetch it from the API:
      return this.getSelf$();
    }
  }

  public getSelf$(): Observable<SelfModel> {
    return this.http.get<SelfModel>(`${environment.BASE_URL}self/`).pipe(
      map((data: Self): SelfModel => {
        this._cachedSelf = data;
        return data;
      })
    );
  }

  public isIntermediary(): Observable<boolean> {
    return this.getSelf$().pipe(map((self: SelfModel) => self.isIntermediary));
  }
}
